import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import SEO from "./Components/Layout/SEO";
import Home from "./Components/Pages/Home/Home";
import About from "./Components/Pages/About/About";
import NotFound from "./Components/Pages/NotFound/NotFound";

function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact={true}>
          <Layout header={true}>
            <SEO
              title={"Home - WebRTC Video Chat"}
              description={
                "Make video and audio calls using webrtc and websockets"
              }
            />
            <Home />
          </Layout>
        </Route>{" "}
        <Route path="/about" exact={true}>
          <Layout header={true}>
            <SEO
              title={"About - WebRTC Video Chat"}
              description={
                "Make video and audio calls using webrtc and websockets"
              }
            />
            <About />
          </Layout>
        </Route>
        <Route path="*">
          <SEO
            title={"404 Not Found - WebRTC Video Chat"}
            description={
              "Make video and audio calls using webrtc and websockets"
            }
          />
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default Routes;
